"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
class DashboardClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = {
        baseURL: process.env.DASHBOARD_SERVICE_URL,
        basicAuthUser: process.env.DASHBOARD_BASIC_AUTH_USER,
        basicAuthPassword: process.env.DASHBOARD_BASIC_AUTH_PASSWORD,
    }) {
        super(config);
        if (!config.baseURL) {
            commons_logs_1.log.warn("DASHBOARD_SERVICE_URL is not configured");
        }
        if (!config.basicAuthUser || !config.basicAuthPassword) {
            commons_logs_1.log.warn("DASHBOARD_BASIC_AUTH_USER and DASHBOARD_BASIC_AUTH_PASSWORD are not configured");
        }
    }
    async getCurrentOrdersV3(sellerId, timezone) {
        try {
            return await this.get(`/v3/seller/${sellerId}/orders/current`, { timezone });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getNonComplianceCases(sellerId) {
        try {
            return await this.get(`/v1/seller/${sellerId}/inbounds/non-compliance-cases`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getUnitsOverview(sellerId) {
        try {
            return await this.get(`/v1/seller/${sellerId}/units/overview`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getSkuReplenishment(sellerId, page, maxDaysLeft, sortMethod, maxRegions, excludeSkusWithInbounds) {
        try {
            return await this.get(`/v1/seller/${sellerId}/inventory/replenishment`, {
                page,
                maxDaysLeft,
                sortMethod,
                maxRegions,
                excludeSkusWithInbounds,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getSkuReplenishmentCsv(sellerId) {
        try {
            return await this.get(`/v1/seller/${sellerId}/inventory/replenishment/csv`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getServiceLevelBreakdownV2(sellerId, startDate, endDate, timezone) {
        try {
            return await this.get(`/v2/seller/${sellerId}/orders/service-level-breakdown`, {
                startDate,
                endDate,
                timezone,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getPromisedDeliverySpeeds(sellerId, startDate, endDate, timezone) {
        try {
            return await this.get(`/v1/seller/${sellerId}/orders/promised-delivery-speeds`, { startDate, endDate, timezone });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getFulfillmentMetricsV2(sellerId, startDate, endDate, timezone) {
        try {
            return await this.get(`/v2/seller/${sellerId}/orders/fulfillment-metrics`, {
                startDate,
                endDate,
                timezone,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getFulfillmentMetrics(sellerId, startDate, endDate, version, timezone) {
        try {
            return await this.get(`/${version}/seller/${sellerId}/orders/fulfillment-metrics`, {
                startDate,
                endDate,
                timezone,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getDeliveredOrdersV2(sellerId, startDate, endDate, timezone) {
        try {
            return await this.get(`/v2/seller/${sellerId}/orders/daily-breakdown`, {
                startDate,
                endDate,
                timezone,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getFulfilledOrders(sellerId, startDate, endDate, timezone) {
        try {
            return await this.get(`/v1/seller/${sellerId}/orders/fulfilled-orders`, {
                startDate,
                endDate,
                timezone,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getFastTagRecommendations(sellerId) {
        try {
            return await this.get(`/v1/seller/${sellerId}/fast-tags/recommendations`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getShopifyFastTagPerformance(sellerId) {
        try {
            return await this.get(`/v1/seller/${sellerId}/fast-tags/performance/shopify`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getReturnItemStatusBreakdown(sellerId, startDate, endDate, timezone) {
        try {
            return await this.get(`/v1/seller/${sellerId}/returns/item-status-breakdown`, { startDate, endDate, timezone });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async getReturnOrdersV3(sellerId, startDate, endDate, timezone) {
        try {
            return await this.get(`/v3/seller/${sellerId}/returns/daily-breakdown`, {
                startDate,
                endDate,
                timezone,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
}
exports.DashboardClient = DashboardClient;
//# sourceMappingURL=DashboardClient.js.map